import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "item" ]

  // Turbo restore visits render cached snapshots without firing any click, so the
  // snapshot's "active" item can disagree with the restored URL: re-derive it here.
  connect() {
    const currentItem = this.itemMatchingLocation()
    if (!currentItem) return

    this.itemTargets.forEach((item) => {
      item.classList.toggle("active", item === currentItem)
    })
  }

  setActive(event) {
    const clickedItem = this.itemTargets.find((item) => item == event.target || item.contains(event.target))
    if (!clickedItem || clickedItem.dataset.verticalNavActivateOnClick === "false") return

    this.itemTargets.forEach((item) => {
      item.classList.toggle("active", item === clickedItem)
    })
    window.history.replaceState(window.history.state, "", clickedItem.dataset.path)
  }

  // Items can share a pathname and differ only by query string, so only an
  // unambiguous match is trusted.
  itemMatchingLocation() {
    return this.uniqueMatch((url) => url.pathname === window.location.pathname && url.search === window.location.search) ||
      this.uniqueMatch((url) => url.pathname === window.location.pathname)
  }

  uniqueMatch(predicate) {
    const matches = this.itemTargets.filter((item) =>
      item.dataset.path && predicate(new URL(item.dataset.path, window.location.origin))
    )

    return matches.length === 1 ? matches[0] : null
  }
}
